import { call, put, takeEvery } from 'redux-saga/effects'
import * as tuyenDungActions from '@redux/ducks/tuyenDung.Ducks'
import * as yeuCauTuyenDungApi from '@apis/tuyenDung/yeuCauTuyenDung.Api'
import * as dangTuyenApi from '@apis/tuyenDung/dangTuyen.Api'
import * as ungVienApi from '@apis/tuyenDung/ungVien.Api'
import * as lichPhongVanApi from '@apis/tuyenDung/lichPhongVan.Api'
import * as thuMoiLamViecApi from '@apis/tuyenDung/thuMoiLamViec.Api'
import * as huongDanNhanViecApi from '@apis/tuyenDung/huongDanNhanViec.Api'
import * as thongKeApi from '@apis/tuyenDung/thongKe.Api'

interface FetchSaga {
  type: string
  payload: string
}

interface FetchHuongDanNhanViecSaga {
  type: string
  payload: {
    candidateId: number
  }
}

function* fetchDanhSachYeuCauTuyenDung({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof yeuCauTuyenDungApi.locYeuCauTuyenDung> = yield call(yeuCauTuyenDungApi.locYeuCauTuyenDung, queryString)
    yield put(tuyenDungActions.layDanhSachYeuCauTuyenDungThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachYeuCauTuyenDungThatBai(error))
  }
}

function* fetchDanhSachDangTuyen({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof dangTuyenApi.locDangTuyen> = yield call(dangTuyenApi.locDangTuyen, queryString)
    yield put(tuyenDungActions.layDanhSachDangTuyenThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachDangTuyenThatBai(error))
  }
}

function* fetchDanhSachUngVien({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof ungVienApi.locUngVien> = yield call(ungVienApi.locUngVien, queryString)
    yield put(tuyenDungActions.layDanhSachUngVienThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachUngVienThatBai(error))
  }
}

function* fetchDanhSachLichPhongVan({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof lichPhongVanApi.locLichPhongVan> = yield call(lichPhongVanApi.locLichPhongVan, queryString)
    yield put(tuyenDungActions.layDanhSachLichPhongVanThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachLichPhongVanThatBai(error))
  }
}

function* fetchDanhSachThuMoiLamViec({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof thuMoiLamViecApi.locThuMoiLamViec> = yield call(thuMoiLamViecApi.locThuMoiLamViec, queryString)
    yield put(tuyenDungActions.layDanhSachThuMoiLamViecThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachThuMoiLamViecThatBai(error))
  }
}

function* fetchDanhSachHuongDanNhanViec({ payload }: FetchHuongDanNhanViecSaga) {
  try {
    const res: ReturnType<typeof huongDanNhanViecApi.layDanhSachChecklistOnboardingTheoUngVien> = yield call(
      huongDanNhanViecApi.layDanhSachChecklistOnboardingTheoUngVien,
      payload.candidateId
    )
    yield put(tuyenDungActions.layDanhSachHuongDanNhanViecThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachHuongDanNhanViecThatBai(error))
  }
}

function* fetchDanhSachThongKe({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof thongKeApi.layThongKeTuyenDung> = yield call(thongKeApi.layThongKeTuyenDung, queryString)
    yield put(tuyenDungActions.layDanhSachThongKeThanhCong(res))
  } catch (error) {
    yield put(tuyenDungActions.layDanhSachThongKeThatBai(error))
  }
}

export default function* watchTuyenDung() {
  yield takeEvery(tuyenDungActions.layDanhSachYeuCauTuyenDung.toString(), fetchDanhSachYeuCauTuyenDung)
  yield takeEvery(tuyenDungActions.layDanhSachDangTuyen.toString(), fetchDanhSachDangTuyen)
  yield takeEvery(tuyenDungActions.layDanhSachUngVien.toString(), fetchDanhSachUngVien)
  yield takeEvery(tuyenDungActions.layDanhSachLichPhongVan.toString(), fetchDanhSachLichPhongVan)
  yield takeEvery(tuyenDungActions.layDanhSachThuMoiLamViec.toString(), fetchDanhSachThuMoiLamViec)
  yield takeEvery(tuyenDungActions.layDanhSachHuongDanNhanViec.toString(), fetchDanhSachHuongDanNhanViec)
  yield takeEvery(tuyenDungActions.layDanhSachThongKe.toString(), fetchDanhSachThongKe)
}

